import useUpdateEffect from './useUpdateEffect';

/**
 * When the value becomes true, the callback will run.
 *
 * NOTE: If the value is true on mount, this will ignore it and will only run the callback the next time it's true.
 */
const useBecameTrueEffect = (callback: () => void, dependency: boolean) => {
    useUpdateEffect(() => {
        if (dependency) callback();
    }, [dependency]);
};

export default useBecameTrueEffect;
